import React, { useState, useEffect, useContext } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import axios from "../axios/axios";
import "../../styles/ControleCaptacao.css";
import Context from "../../Context/Context";
import NotificacaoDeErro from "../Notificacao/NotificacaDeErro";

const ControleDeCaptacao = () => {
  const [metas, setMetas] = useState();
  const { usuario } = useContext(Context);
  const [msn, setMsn] = useState("");
  const [mostrarNotificacaoDeErro, setMostrarNotificacaoDeErro] =
    useState(false);

  const findMetas = async () => {
    try {
      const { data } = await axios.get("/indicacao/metas", {
        headers: { Authorization: usuario.token },
      });
      setMetas(data);
      console.log(data);
    } catch (error) {
      setMsn(`Error: ${error}`);
      setMostrarNotificacaoDeErro(true);
    }
  };
  useEffect(() => {
    const execute = async () => {
      await findMetas();
    };
    execute();
  }, []);
  // Escuta mudanças no contexto para atualizar as metas imediatamente
  useEffect(() => {
    if (usuario?.novaMetaInserida) {
      findMetas(); // Atualiza as metas imediatamente após a inserção
    }
  }, [usuario?.novaMetaInserida]);
  const metaImediataEquipe = () => {
    return metas?.imediatas?.find((e) => e?.metaEquipe != 0)?.metaEquipe || 0;
  };
  const metaMediataEquipe = () => {
    return metas?.mediatas?.find((e) => e?.metaEquipe != 0)?.metaEquipe || 0;
  };
  const contarMensaisMediatas = () => {
    return metas?.mediatas.reduce((a, c) => a + c?.soma, 0);
  };
  const contarMensaisImediatas = () => {
    return metas?.imediatas.reduce((a, c) => a + c?.soma, 0);
  };
  const contarDiariasMediatas = () => {
    const metasDiarias = metas?.usuarios_captacoes_diarias || {};
    return Object.values(metasDiarias).reduce((a, c) => a + c?.mediatas, 0);
  };
  const contarDiariasImediatas = () => {
    const metasDiarias = metas?.usuarios_captacoes_diarias || {};
    return Object.values(metasDiarias).reduce((a, c) => a + c?.imediatas, 0);
  };
  const formatarDadosDiarios = (tipo) => {
    const metasDiarias = metas?.usuarios_captacoes_diarias || {};
    return Object.entries(metasDiarias).map(([data, valores]) => ({
      data: metas["usuarios"].find((e) => e?.id == data)?.nome,
      quantidade: valores[tipo],
    }));
  };
  const formatarDadosMensais = (tipo) => {
    return (
      metas?.[tipo]?.map((item) => ({
        nome: metas["usuarios"].find((e) => e.id == item.usuario_id).nome, // Mostra o nome do usuário
        quantidade: item.soma,
      })) || []
    );
  };
  const formatarRanking = () => {
    const usuarios = metas?.usuarios_captacoes_mensais || {}; // Considera captações mensais
    const ids = Object.keys(usuarios);
    return Object.entries(usuarios)
      .map(([_, valores], i) => ({
        usuario: metas["usuarios"].find((e) => e.id == ids[i]).nome, // Mostra o nome do usuário
        total: valores.imediatas + valores.mediatas, // Soma imediatas e mediatas
      }))
      .sort((a, b) => b.total - a.total); // Ordena em ordem decrescente pelo total
  };
  return (
    <div className="controle-captacao-container">
      <div className="topo-controle">
        <h1 className="titulo">Controle de Captação</h1>
      </div>
      <div className="metas"></div>
      <div className="faltam">
        <h2>Metas e Progresso:</h2>
        <p>Diária Imediata: {contarDiariasImediatas()} </p>
        <p>Diária Mediata: {contarDiariasMediatas()} </p>
        {metas?.celula === "Nenhuma" ? (
          <>
            <p>
              Mensal Equipe Mediata: {contarMensaisMediatas()}/
              {metaMediataEquipe()}
            </p>
            <p>
              Mensal Equipe Imediata: {contarMensaisImediatas()}/
              {metaImediataEquipe()}{" "}
            </p>
          </>
        ) : (
          <>
            {metas?.celula == "Mediata" ? (
              <>
                <p>
                  Mensal Individual {metas?.celula}: {metas?.soma_usuario}/
                  {metas?.[`meta_usuario_${metas?.["celula"].toLowerCase()}`] ||
                    0}{" "}
                </p>
                <p>
                  Mensal Equipe {metas?.celula}: {contarMensaisMediatas()}/
                  {metas?.[`meta_equipe_${metas?.["celula"].toLowerCase()}`] ||
                    0}
                </p>
              </>
            ) : (
              <>
                <p>
                  Mensal Individual {metas?.celula}: {metas?.soma_usuario}/
                  {metas?.[`meta_usuario_${metas?.["celula"].toLowerCase()}`] ||
                    0}{" "}
                </p>
                <p>
                  Mensal Equipe {metas?.celula}: {contarDiariasImediatas()}/
                  {metas?.[`meta_equipe_${metas?.["celula"].toLowerCase()}`] ||
                    0}
                </p>
              </>
            )}
          </>
        )}
      </div>
      <h2 className="subtitulo">Captação Diária - Imediatas</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={formatarDadosDiarios("imediatas")}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="data" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="quantidade" fill="#4CAF50" radius={[5, 5, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <h2 className="subtitulo">Captação Diária - Mediatas</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={formatarDadosDiarios("mediatas")}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="data" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="quantidade" fill="#FF9800" radius={[5, 5, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <h2 className="subtitulo">Captação Mensal - Imediatas</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={formatarDadosMensais("imediatas")}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="nome" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="quantidade" fill="#2196F3" radius={[5, 5, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <h2 className="subtitulo">Captação Mensal - Mediatas</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={formatarDadosMensais("mediatas")}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="nome" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="quantidade" fill="#F44336" radius={[5, 5, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <h2 className="subtitulo">Ranking de Captações</h2>
      <table className="tabela-ranking">
        <thead>
          <tr>
            <th>Posição</th>
            <th>Usuário</th>
            <th>Total de Captações</th>
          </tr>
        </thead>
        <tbody>
          {formatarRanking().map((usuario, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{usuario.usuario}</td>
              <td>{usuario.total}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <NotificacaoDeErro
        mostrar={mostrarNotificacaoDeErro}
        onClose={() => setMostrarNotificacaoDeErro(false)}
        mensagem={msn}
      />
    </div>
  );
};
export default ControleDeCaptacao;
